import type { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';
import type { Role } from 'src/features/skills-matrix/skills-matrix.types';

import type { SkillMatrixSegmentValue, SkillsMatrix } from './skill-matrix-graphic.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserSkillsMatrix: builder.query<
      ApiResponse<SkillsMatrix>,
      { role: Role | undefined; segment: SkillMatrixSegmentValue }
    >({
      query: ({ role, segment }) => ({
        method: 'GET',
        url: role ? `users/skills?role=${role}&segment=${segment}` : 'users/skills',
      }),
    }),
  }),
});

export const { useGetUserSkillsMatrixQuery } = extendedApiSlice;
